// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3241":"345785cd6a7bca88","9286":"db42615081ed9b4f"}[chunkId] + ".css";
};